import type { SVGProps } from 'react';

export function IconPlay(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
            <path d="M7 4.5v15l13-7.5z" />
        </svg>
    );
}
